<template>
  <div id="UserPhoto">
    <div v-if="user.loaded == true">
      <div class="photo-container" @click="triggerFileInputClick">
        <img id="user_image" v-bind:src="image" v-bind:alt="fullname" />
      </div>
    </div>
    <div v-if="user.loaded == true">
      <div v-if="this.edit_mode == true">
        <form>
          <input
            ref="fileInput"
            type="file"
            id="avatar"
            name="image"
            accept="image/png, image/jpeg"
            @change="uploadPhoto"
          />
          <button>Upload Image</button>
        </form>
        <div class="edit-info">
          <p><strong class="error">Important Information</strong></p>
          <p>
            <strong
              >It is crucial that you use your legal name as it appears on your
              government issued Photo ID or you won't be able to access the
              festival.</strong
            >
          </p>
          <p>
            <strong
              >Please
              <a href="mailto:sales@shambhalamusicfestival.com">contact us</a>
              if a change needs to be made to your email address.</strong
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UserPhoto",
  data() {
    return {
      user: window.portal.user,
    };
  },
  computed: {
    image: function () {
      return window.portal.user.image != ""
        ? `${window.portal.user.image}`
        : "/images/user_nophoto.svg";
    },
    edit_mode: function () {
      return window.portal.user.edit_mode ? true : false;
    },
    fullname: function () {
      return `${this.user.first_name} ${this.user.last_name}`;
    },
  },
  methods: {
    triggerFileInputClick() {
      if (this.edit_mode) {
        this.$refs.fileInput.click();
      }
    },
    uploadPhoto(e) {
      if (e) {
        e.preventDefault();
      }
      if (e.target.files.length === 1) {
        const config = { headers: { "Content-Type": "multipart/form-data" } };
        const imageFile = e.target.files[0];
        const formData = new FormData();

        formData.append("image", imageFile);
        formData.append("confirm", window.portal.user.id.decode().encode());

        axios.defaults.headers.common["X-Auth-Token"] =
          window.portal.session.token;
        axios
          .post(
            `${window.portal.api_server}/userportal/userinfo/image`,
            formData,
            config
          )
          .then((r) => {
            window.portal.user.image = `${window.portal.api_server}${
              r.data.data.image
            }?t=${new Date().getTime()}`;
          })
          .catch((e) => {
            window.debug(e);
          });
      }
    },
  },
};
</script>

<style>
#UserPhoto .photo-container {
  display: block;
  width: 100%;
  height: auto;
  position: relative;
}
#UserPhoto .photo-container:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}
#UserPhoto img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0px;
  left: 0px;
  object-fit: cover;
}
#UserPhoto form {
  display: block;
  text-align: center;
}
#UserPhoto .edit-info {
  margin: 20px 0;
  padding: 15px;
  background: #eee;
  font-size: 13px;
  text-align: left;
  border: 1px solid #900;
}
.edit-info a,
.edit-info a:hover {
  text-decoration: underline;
}
.edit-info strong.error {
  text-transform: uppercase;
  display: block;
  white-space: nowrap;
}
</style>